<style>

input[type="text"]{
  background-color: inherit;
  border: 0;
  border-radius: 0;
  border-bottom: 2px white solid;
  color: white;
  background-color: rgba(255,255,255,0.2);
}

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}

</style>

<div class="bg">
  <div class="title-signup">Create a username</div>
  <div class="margin">
    <!-- <input type="text" bind:value="{username}"> -->
    <ValidInput bind:value="{username}" valid="{valid}" on:changed="{check}"></ValidInput>
  </div>
  <div class="margin small"></div>
  
  <div class="has-buttons"></div>
  
</div>

<!-- <div class="next">
  <button on:click="{next}" disabled="{nextDisabled}">Next</button>
</div> -->
<NextButton on:click="{next}" disabled="{nextDisabled}"></NextButton>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import ValidInput from "../../../../components/ValidInput.svelte";
import NextButton from "../../../../components/NextButton.svelte";

import Signup from "../../../../helpers/Signup.js";
import Validate from "../../../../helpers/Validate.js";
import Normalize from "../../../../helpers/Normalize.js";

import { onMount } from "svelte";
onMount(async () => {
  try {
    Signup.verifyPersonalObject();
  } catch (e) {
    console.log("error:", e);
    
    if (e == "Must start from beginning") {
      document.location = "/";
    }
    
    return;
  }
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  allowSignup = true;
  // Signup.saveToPersonalObject("username", "");
  usernameSaved = Signup.getPersonalObject("usernameSaved");
  username = Signup.getPersonalObject("username");
  
  if (usernameSaved == true) {
    valid = true;
    nextDisabled = false;
  } else {
    check();
  }
  
});

let allowSignup = false;
let username = "alisonjames";
let usernameSaved = false;
let valid = false;
let nextDisabled = true;
let signupDelayHandle = null;
let lastUsername = "";


function check(e) {
  clearTimeout(signupDelayHandle);
  
  if (username == lastUsername) return;
  
  usernameSaved = false;
  
  signupDelayHandle = setTimeout( async () => {
    lastUsername = username;
    try {
      Validate.allowSignup(allowSignup);
      Validate.username(username);
      await Signup.isUsernameUsed(username);
      valid = true;
      nextDisabled = false;
    } catch (e) {
      valid = false;
      nextDisabled = true;
      console.log("error:", e);
    }
  }, 450);
  
}


async function next() {
  if (usernameSaved == false) {
    username = Normalize.email(username);
    await Signup.saveToPersonalObject("username", username);
    await Signup.saveToPersonalObject("usernameSaved", true);
    await Signup.saveUsername();
  }
  
  push("/signup/profile/personal/password");
}


</script>